import styled from "styled-components";

const FourOFour = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 5rem;
font-weight: 700
`;

export default function DefaultSpace() {
    return (
        <FourOFour className="App-col">
            <p>404</p>
        </FourOFour>
    )
}